import { FSharpRef, Record } from "../../../../fable_modules/fable-library-js.4.19.3/Types.js";
import { record_type, string_type } from "../../../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { S3Context_$reflection } from "../../../../Common/AwsCommon.js";
import { AsyncResultComputationExpression_asyncResult, AsyncResultComputationExpression_AsyncResultBuilder__Return_1505, AsyncResult_ofAsync, AsyncResultComputationExpression_AsyncResultBuilder__Bind_454FBA93, AsyncResultComputationExpression_AsyncResultBuilder__Delay_Z5276B41B } from "../../../../fable_modules/AsyncResult.0.3.0/Result.fs.js";
import { awaitPromise } from "../../../../fable_modules/fable-library-js.4.19.3/Async.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise as promise_3 } from "../../../../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { fetch$ } from "../../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { ofArray, forAll, empty } from "../../../../fable_modules/fable-library-js.4.19.3/List.js";
import { Pdf_Spacing_leftMargin, Pdf_Table_Style, Pdf_Table_Adv_make, Pdf_Autotable, Pdf_JsPdf, Pdf_Images_Adv_addImage } from "../ReportPdfHelpers.js";
import { fold } from "../../../../fable_modules/fable-library-js.4.19.3/Array.js";
import { Shared_ptToMm } from "../../../../Visualization/VisualizationShared.js";
import { day, month, year, create, now, date as date_1, tryParse, minValue } from "../../../../fable_modules/fable-library-js.4.19.3/DateOffset.js";
import { isMatch } from "../../../../fable_modules/fable-library-js.4.19.3/RegExp.js";
import { compare } from "../../../../fable_modules/fable-library-js.4.19.3/Date.js";
import { map2 } from "../../../../fable_modules/fable-library-js.4.19.3/Option.js";

export class Shared_UniversalArgs extends Record {
    constructor(token, s3Context) {
        super();
        this.token = token;
        this.s3Context = s3Context;
    }
}

export function Shared_UniversalArgs_$reflection() {
    return record_type("RAWMap.Client.Study.CustomStentReport.ReportPdf.Sections.Shared.UniversalArgs", [], Shared_UniversalArgs, () => [["token", string_type], ["s3Context", S3Context_$reflection()]]);
}

export class Shared_HeaderArgs extends Record {
    constructor(PatientName, PatientId, PatientGender, ReferringMD, StudyDate, ReportCreationDate) {
        super();
        this.PatientName = PatientName;
        this.PatientId = PatientId;
        this.PatientGender = PatientGender;
        this.ReferringMD = ReferringMD;
        this.StudyDate = StudyDate;
        this.ReportCreationDate = ReportCreationDate;
    }
}

export function Shared_HeaderArgs_$reflection() {
    return record_type("RAWMap.Client.Study.CustomStentReport.ReportPdf.Sections.Shared.HeaderArgs", [], Shared_HeaderArgs, () => [["PatientName", string_type], ["PatientId", string_type], ["PatientGender", string_type], ["ReferringMD", string_type], ["StudyDate", string_type], ["ReportCreationDate", string_type]]);
}

export const Shared_footerText = ["Refer to Instructions for Use at eifu.goremedical.com for a complete description of applicable indications,", "warnings, precautions and contradictions for the markets where this product is available.", "Products listed may not be available in all markets.", "© 2025 W. L. Gore & Associates, Inc. All rights reserves. All trademarks references are trademarks of either a member", "of the Gore group of affiliated companies or their respective owners. \"Together, improving life\" mark and design are", "trademarks of a Gore company. 25MD1062-EN01 SEPTEMBER 2025"];

export const Shared_headerHeight = 50;

export const Shared_footerHeight = 40;

export function Shared_header(args, doc) {
    return AsyncResultComputationExpression_AsyncResultBuilder__Delay_Z5276B41B(AsyncResultComputationExpression_asyncResult, () => AsyncResultComputationExpression_AsyncResultBuilder__Bind_454FBA93(AsyncResultComputationExpression_asyncResult, AsyncResult_ofAsync(awaitPromise(PromiseBuilder__Run_212F1D4B(promise_3, PromiseBuilder__Delay_62FBFDE1(promise_3, () => (fetch$("Header-LTR.png", empty()).then((_arg) => (_arg.arrayBuffer()))))))), (_arg_1) => {
        const fileArray = _arg_1;
        const pageSize = doc.internal.pageSize;
        const pageWidth = pageSize.getWidth();
        const pageHeight = pageSize.getHeight();
        const processed = doc.processPNG(fileArray, 0, "banner", "NONE");
        const pixelWidth = processed.width;
        const mmHeight = pageWidth * (processed.height / pixelWidth);
        const doc_1 = Pdf_Images_Adv_addImage(fileArray, 0, 0, pageWidth, mmHeight, doc);
        const headerTableRows = [["Patient Name:", args.PatientName, "Referring MD:", args.ReferringMD], ["Patient ID:", args.PatientId, "Study Date:", args.StudyDate], ["Patient Gender:", args.PatientGender, "Report Creation Date:", args.ReportCreationDate]];
        const jsPDF = Pdf_JsPdf.jsPDF;
        Pdf_Autotable.applyPlugin(jsPDF);
        return AsyncResultComputationExpression_AsyncResultBuilder__Return_1505(AsyncResultComputationExpression_asyncResult, Pdf_Table_Adv_make({
            body: headerTableRows,
            startY: mmHeight,
            styles: {
                fontSize: 8,
                minCellWidth: Pdf_Table_Style.minCellWidth,
            },
        }, doc_1));
    }));
}

export function Shared_footer(doc) {
    return AsyncResultComputationExpression_AsyncResultBuilder__Delay_Z5276B41B(AsyncResultComputationExpression_asyncResult, () => {
        const pageSize = doc.internal.pageSize;
        const pageWidth = pageSize.getWidth();
        const pageHeight = pageSize.getHeight();
        return AsyncResultComputationExpression_AsyncResultBuilder__Bind_454FBA93(AsyncResultComputationExpression_asyncResult, AsyncResult_ofAsync(awaitPromise(PromiseBuilder__Run_212F1D4B(promise_3, PromiseBuilder__Delay_62FBFDE1(promise_3, () => (fetch$("eifu-symbol.png", empty()).then((_arg) => (_arg.arrayBuffer()))))))), (_arg_1) => {
            const fileArrayEifu = _arg_1;
            const processedEifu = doc.processPNG(fileArrayEifu, 0, "eifu", "NONE");
            const pixelWidthEifu = processedEifu.width;
            const mmHeightEifu = 30 * (processedEifu.height / pixelWidthEifu);
            const doc_1 = Pdf_Images_Adv_addImage(fileArrayEifu, Pdf_Spacing_leftMargin, pageHeight - Shared_footerHeight, 30, mmHeightEifu, doc);
            const previousFont = doc_1.getFontSize();
            doc_1.setFontSize(8);
            const doc_3 = fold((tupledArg, t) => {
                const doc_2 = tupledArg[0];
                const y = tupledArg[1];
                const lineHeight = Shared_ptToMm(doc_2.getLineHeight());
                return [doc_2.text(t, Pdf_Spacing_leftMargin, y), y + lineHeight];
            }, [doc_1, ((pageHeight - Shared_footerHeight) + mmHeightEifu) + 5], Shared_footerText)[0];
            doc_3.setFontSize(previousFont);
            return AsyncResultComputationExpression_AsyncResultBuilder__Bind_454FBA93(AsyncResultComputationExpression_asyncResult, AsyncResult_ofAsync(awaitPromise(PromiseBuilder__Run_212F1D4B(promise_3, PromiseBuilder__Delay_62FBFDE1(promise_3, () => (fetch$("gore_logo_color_positive_rgb.png", empty()).then((_arg_2) => (_arg_2.arrayBuffer()))))))), (_arg_3) => {
                const fileArrayLogo = _arg_3;
                const processedLogo = doc_3.processPNG(fileArrayLogo, 0, "logo", "NONE");
                const pixelWidthLogo = processedLogo.width;
                const mmHeightLogo = 30 * (processedLogo.height / pixelWidthLogo);
                const doc_4 = Pdf_Images_Adv_addImage(fileArrayLogo, (pageWidth - 30) - 5, (pageHeight - mmHeightLogo) - 5, 30, mmHeightLogo, doc_3);
                return AsyncResultComputationExpression_AsyncResultBuilder__Bind_454FBA93(AsyncResultComputationExpression_asyncResult, AsyncResult_ofAsync(awaitPromise(PromiseBuilder__Run_212F1D4B(promise_3, PromiseBuilder__Delay_62FBFDE1(promise_3, () => (fetch$("RxOnly.png", empty()).then((_arg_4) => (_arg_4.arrayBuffer()))))))), (_arg_5) => {
                    const fileArrayRx = _arg_5;
                    const processedRx = doc_4.processPNG(fileArrayRx, 0, "rx", "NONE");
                    const pixelWidthRx = processedRx.width;
                    const mmHeightRx = 6 * (processedRx.height / pixelWidthRx);
                    return AsyncResultComputationExpression_AsyncResultBuilder__Return_1505(AsyncResultComputationExpression_asyncResult, Pdf_Images_Adv_addImage(fileArrayRx, (pageWidth - 6) - 85, (pageHeight - mmHeightRx) - 22, 6, mmHeightRx, doc_4));
                });
            });
        });
    });
}

export function TimeDelta_tryParseDateTime(input) {
    let matchValue;
    let outArg = minValue();
    matchValue = [tryParse(input, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    if (matchValue[0]) {
        return matchValue[1];
    }
    else {
        return undefined;
    }
}

export function TimeDelta_parseYYYYMMDD(input) {
    if (isMatch(/[\d]{4}-[\d]{2}-[\d]{2}/gu, input)) {
        return TimeDelta_tryParseDateTime(input);
    }
    else if (input.length === 8) {
        return TimeDelta_tryParseDateTime(`${input.slice(0, 3 + 1)}-${input.slice(4, 5 + 1)}-${input.slice(6, 7 + 1)}`);
    }
    else {
        return undefined;
    }
}

export function TimeDelta_validateAcquisitionDates(current, previous) {
    let date1, date2, d1, d2;
    const isDateBetweenTodayAnd1980 = (date) => {
        if (date == null) {
            return false;
        }
        else {
            const d = date;
            const today = date_1(now());
            const jan1_1980 = create(1980, 1, 1, 0, 0, 0, 0);
            if (compare(date_1(d), date_1(jan1_1980)) >= 0) {
                return compare(date_1(d), today) <= 0;
            }
            else {
                return false;
            }
        }
    };
    return forAll((x) => x, ofArray([isDateBetweenTodayAnd1980(current), isDateBetweenTodayAnd1980(previous), (date1 = current, (date2 = previous, (date1 != null) && ((date2 != null) && ((d1 = date1, (d2 = date2, compare(d1, d2) > 0))))))]));
}

export function TimeDelta_calculateTimeDelta(currentStudyAcquisitionDate, previousStudyAcquisitionDate) {
    const currentDate = TimeDelta_parseYYYYMMDD(currentStudyAcquisitionDate);
    const previousDate = TimeDelta_parseYYYYMMDD(previousStudyAcquisitionDate);
    if (TimeDelta_validateAcquisitionDates(currentDate, previousDate)) {
        return map2((current, previous) => {
            const totalMonths = ((((year(current) - year(previous)) * 12) + (month(current) - month(previous))) - (((day(current) - day(previous)) < 0) ? 1 : 0)) | 0;
            return [~~(totalMonths / 12), totalMonths % 12];
        }, currentDate, previousDate);
    }
    else {
        return undefined;
    }
}

